import { useState, useEffect, useRef } from 'react';
import cmdImage from './cmd.png';
import ReactModal from 'react-modal-resizable-draggable';

import closeButton from '../modal-tab/header/Vector.svg';
import maxButton from '../modal-tab/header/maxi.svg';
import minButton from '../modal-tab/header/mini.png';
import tabButton from '../modal-tab/header/tab.svg';

import fileSystem from './file-system';  
import '../index.css';

export default function Cmd (props) {
    const entranceLines = [
        { text: "Areen Portfolio Shell [Version 1.0.0]", color: "white" },
        { text: "(C) 2025 Areen Corp. All rights reserved.", color: "white" },
        { text: "", color: "white" },
        { text: "Type 'help' for a list of commands.", color: "white" }
    ];

    const [max, setMax] = useState(false);
    const [lines, setLines] = useState(entranceLines);
    const [input, setInput] = useState("");
    const [showCursor, setShowCursor] = useState(true);
    const [currentPath, setCurrentPath] = useState("C:\\Users\\Areen");

    const [history, setHistory] = useState([]);
    const [historyIndex, setHistoryIndex] = useState(-1);

    const terminalRef = useRef(null);
    const inputRef = useRef(null);

    useEffect(() => {
        const timer = setInterval(() => setShowCursor((s) => !s), 500);
        return () => clearInterval(timer);
    }, []);

    useEffect(() => {
        if (terminalRef.current) {
            terminalRef.current.scrollTop = terminalRef.current.scrollHeight;
        }
    }, [lines]);

    useEffect(() => {
        const handleClick = () => {
            if (inputRef.current) {
                inputRef.current.focus();
                const el = inputRef.current;
                el.selectionStart = el.selectionEnd = el.value.length;
            }
        };
        const term = terminalRef.current;
        if (term) term.addEventListener("click", handleClick);
        return () => term && term.removeEventListener("click", handleClick);
    }, []);

    useEffect(() => {
        if (inputRef.current) {
            const el = inputRef.current;
            el.selectionStart = el.selectionEnd = el.value.length;
        }
    }, [input]);

    const triggerMaxMin = () => setMax(!max);
    const handleTabMinimize = (e) => props.triggerTabMinimize(e);
    const handleTabClose = (e) => props.trigger(e);

    const resolveDir = (path) => {
        const parts = path.split("\\").filter(Boolean);
        let node = fileSystem["C:\\Users\\Areen"];

        if (parts.length === 3) {
            return node;
        }

        for (let i = 3; i < parts.length; i++) {
            if (node.children && node.children[parts[i]]) {
                node = node.children[parts[i]];
            } else {
                return null;
            }
        }
        return node;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!input.trim()) return;
        let newLines = [...lines, { text: currentPath + ">" + input, color: "white" }];
        const cmd = input.trim();
        setHistory((prev) => [...prev, cmd]);
        setHistoryIndex(-1);

        if (cmd === "help") {
            newLines.push({
                text: "Supported commands: help, echo <text>, cls, exit, cd, ls, cat <file>, open <file>, less <file>, pwd, whoami",
                color: "green"
            });
        } else if (cmd === "cls") {
            newLines = [];
        } else if (cmd === "exit") {
            handleTabClose(e);
        } else if (cmd.startsWith("echo ")) {
            newLines.push({ text: cmd.slice(5), color: "green" });
        } else if (cmd === "pwd") {
            newLines.push({ text: currentPath, color: "green" });
        } else if (cmd === "whoami") {
            newLines.push({ text: "Areen", color: "green" });
        } else if (cmd.startsWith("cd")) {
            const parts = cmd.split(" ");
            if (parts.length === 1) {
                newLines.push({ text: currentPath, color: "green" });
            } else {
                const dirName = parts[1];
                if (dirName === "..") {
                    if (currentPath !== "C:\\Users\\Areen") {
                        let newPath = currentPath.split("\\").slice(0, -1).join("\\");
                        if (newPath.startsWith("C:\\Users\\Areen")) {
                            setCurrentPath(newPath);
                        } else {
                            setCurrentPath("C:\\Users\\Areen"); 
                        }
                    } else {
                        newLines.push({ text: "Already at root directory", color: "red" });
                    }
                } else {
                    const node = resolveDir(currentPath);
                    if (node && node.children && node.children[dirName] && node.children[dirName].type === "dir") {
                        setCurrentPath(currentPath + "\\" + dirName);
                    } else {
                        newLines.push({ text: "The system cannot find the path specified.", color: "red" });
                    }
                }
            }

        } else if (cmd === "ls") {
            const node = resolveDir(currentPath);
            if (node && node.children) {
                let items = Object.keys(node.children).map((k) => ({
                    name: k,
                    ...node.children[k]
                }));
                items.forEach((item) => {
                    newLines.push({
                        text: `${item.type === "dir" ? "<DIR>" : "     "}  ${item.name}`,
                        color: item.type === "dir" ? "white" : "green"
                    });
                });
            }

        } else if (cmd.startsWith("cat ") || cmd.startsWith("less ")) {
            const parts = cmd.split(" ");
            if (parts.length < 2) {
                newLines.push({ text: "Usage: cat <filename>", color: "red" });
            } else {
                const fileName = parts[1];
                const node = resolveDir(currentPath);
                if (node && node.children && node.children[fileName]) {
                    newLines.push({ text: node.children[fileName].content || "", color: "green" });
                } else {
                    newLines.push({ text: "The system cannot find the file specified.", color: "red" });
                }
            }

        } else if (cmd.startsWith("open ")) {
            const parts = cmd.split(" ");
            if (parts.length < 2) {
                newLines.push({ text: "Usage: open <filename>", color: "red" });
            } else {
                const fileName = parts[1];
                const node = resolveDir(currentPath);
                if (node && node.children && node.children[fileName] && node.children[fileName].open) {
                    const openConfig = node.children[fileName].open;
                    if (openConfig.type === "link") {
                        window.open(openConfig.element || openConfig.href, "_blank");
                        newLines.push({ text: `Opened link: ${openConfig.element || openConfig.href}`, color: "green" });
                    } else if (openConfig.type === "component") {
                        props.triggerComponentOpen({
                            currentTarget: { id: openConfig.id }
                        });
                    }
                } else {
                    newLines.push({ text: "The system cannot find the file specified.", color: "red" });
                }
            }

        } else {
            newLines.push({ text: `'${input}' is not recognized as a command.`, color: "red" });
            newLines.push({ text: "Type 'help' for a list of commands.", color: "white" });
        }
        setLines(newLines);
        setInput("");
    };

    const handleKeyDown = (e) => {
        if (e.key === "ArrowUp") {
            e.preventDefault();
            e.stopPropagation();
            if (history.length > 0) {
                const newIndex = historyIndex === -1 ? history.length - 1 : Math.max(0, historyIndex - 1);
                setHistoryIndex(newIndex);
                setInput(history[newIndex]);
            }
        } else if (e.key === "ArrowDown") {
            e.preventDefault();
            e.stopPropagation();
            if (historyIndex !== -1) {
                const newIndex = historyIndex + 1;
                if (newIndex < history.length) {
                    setHistoryIndex(newIndex);
                    setInput(history[newIndex]);
                } else {
                    setHistoryIndex(-1);
                    setInput("");
                }
            }
        }
    };

    return (
        <div>
            <ReactModal isOpen={props.isOpen} disableResize={true}>
                <div className={`${max ? 'modal-container-max' : 'modal-container'}`}>
                    {/* Header */}
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '3px' }}>
                            <img src={cmdImage} height="20px" width="20px" style={{ paddingLeft: '5px' }} alt="" />
                            <div style={{ paddingLeft: '8px', fontFamily: 'Helvetica', fontSize: '13px' }}> Command Prompt </div>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <button id={'cmd'} className="topbar-minimize-button" onClick={handleTabMinimize}>
                                <img id={'cmd'} src={tabButton} style={{ height: '10px', width: '10px' }} alt="" />
                            </button>
                            <button className="topbar-maximize-button" onClick={triggerMaxMin}>
                                <img src={max ? minButton : maxButton} style={{ height: '14px', width: '14px' }} alt="" />
                            </button>
                            <button id={'cmd'} className="topbar-close-button" onClick={handleTabClose}>
                                <img id={'cmd'} src={closeButton} style={{ height: '14px', width: '14px' }} alt="" />
                            </button>
                        </div>
                    </div>

                    {/* Terminal */}
                    <div ref={terminalRef} className={`terminal ${max && 'terminal-fullscreen'}`}>
                        {lines.map((line, idx) => (
                            <pre key={idx} style={{ color: line.color }}>{line.text}</pre>
                        ))}
                        <form id={'cmd'} onSubmit={handleSubmit} style={{ display: "flex" }}>
                            <span style={{ color: "white" }}>{currentPath}&gt;</span>
                            <input
                                ref={inputRef}
                                id={'cmd'}
                                type="text"
                                value={input}
                                onChange={(e) => setInput(e.target.value)}
                                onKeyDown={handleKeyDown}
                                className="cmd-input"
                                autoFocus
                            />
                            {showCursor && !input && <span className="cursor">|</span>}
                        </form>
                    </div>
                </div>
            </ReactModal>
        </div>
    );
}
